const $6401b53bf7af177a$var$DEFAULT_SETTINGS = {
    arrowHeadSize: 10,
    dropCrossSize: 12,
    thickArrowThickness: 1.0,
    labelOffset: 10,
    corruptStartRatio: 0.85,
    dropStartRatio: 0.85,
    squiggleSize: 20,
    squiggleCount: 2,
    timeTickInterval: 40,
    participantSpacing: 240,
    participantLabelHeight: 30,
    annotationWidth: 80,
    participantFontSize: 20,
    messageFontSize: 15,
    paddingX: 30,
    paddingY: 20,
    showGrid: false,
    showTimeTicks: false,
    timeTickStep: 1,
    timeUnit: ""
};
function $6401b53bf7af177a$var$parseString(val) {
    const v = val.trim();
    // Strip quotes if present
    if (v.startsWith('"') && v.endsWith('"') || v.startsWith("'") && v.endsWith("'")) return v.slice(1, -1);
    return v;
}
function $6401b53bf7af177a$var$parseNumber(val) {
    const v = $6401b53bf7af177a$var$parseString(val);
    if (v === "") return null;
    // Percentage: "85%" -> 0.85
    if (v.endsWith("%")) {
        const numPart = v.slice(0, -1);
        const n = Number(numPart);
        if (numPart !== "" && !isNaN(n)) return n / 100;
    }
    // Pixels: "20px" -> 20
    if (v.endsWith("px")) {
        const numPart = v.slice(0, -2);
        const n = Number(numPart);
        if (numPart !== "" && !isNaN(n)) return n;
    }
    // Strict number coercion
    const n = Number(v);
    return isNaN(n) ? null : n;
}
function $6401b53bf7af177a$var$parseBoolean(val) {
    const v = $6401b53bf7af177a$var$parseString(val).toLowerCase();
    if (v === "true") return true;
    if (v === "false") return false;
    return null;
}
function $6401b53bf7af177a$export$98e6a39c04603d36(src) {
    const settings = {
        ...$6401b53bf7af177a$var$DEFAULT_SETTINGS
    };
    const participants = [];
    const actions = [];
    let numAnnotations = 0;
    const lines = src.split("\n");
    for (let line of lines){
        // Strip inline comments, respecting quotes
        line = line.replace(/("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')|\/\/.*$/g, (m, g1)=>g1 ? g1 : "").trim();
        if (!line) continue;
        // overwrite default settings
        if (line.startsWith("def ")) {
            // Use regex to capture the full value which might contain spaces and quotes
            const match = line.match(/^def\s+([\w.]+)\s+(.+)$/);
            if (!match) continue;
            const name = match[1];
            const rawValue = match[2];
            const normalizedName = name.toLowerCase();
            // find exact match (case-insensitive)
            const targetKey = Object.keys($6401b53bf7af177a$var$DEFAULT_SETTINGS).find((k)=>k.toLowerCase() === normalizedName);
            if (targetKey) {
                const defaultValue = $6401b53bf7af177a$var$DEFAULT_SETTINGS[targetKey];
                // Use specialized parsers based on the target type
                if (typeof defaultValue === "number") {
                    const val = $6401b53bf7af177a$var$parseNumber(rawValue);
                    if (val !== null) settings[targetKey] = val;
                } else if (typeof defaultValue === "boolean") {
                    const val = $6401b53bf7af177a$var$parseBoolean(rawValue);
                    if (val !== null) settings[targetKey] = val;
                } else if (typeof defaultValue === "string") settings[targetKey] = $6401b53bf7af177a$var$parseString(rawValue);
            }
            continue;
        }
        // participants
        // Example: participant Client c1
        // Example: participant "Web Server" ws
        if (line.startsWith("participant ")) {
            const match = line.match(/^participant\s+(?:(?:"([^"]+)")|(\S+))\s+(\w+)/);
            if (!match) continue;
            const name = match[1] || match[2];
            const alias = match[3];
            participants.push({
                name: name,
                alias: alias,
                column: participants.length
            });
            continue;
        }
        // annotations
        const annMatch = line.match(/^(\w+)(?:\s*@([\d.%px]+))?\s*([<>])\s*"(.+)"/);
        if (annMatch) {
            numAnnotations++;
            actions.push({
                type: "annotation",
                participant: annMatch[1],
                height: annMatch[2] ? $6401b53bf7af177a$var$parseNumber(annMatch[2]) ?? undefined : undefined,
                side: annMatch[3] === "<" ? "left" : "right",
                text: annMatch[4]
            });
            continue;
        }
        // arrows
        const arrowMatch = line.match(/^(\w+)(?:\s*@([\d.%px]+))?\s*(?:\[([\d.]+)\])?\s*(->|=>|~>|-x)(?:\[([\d.]+)\])?\s*(?:@([\d.%px]+)\s+)?(\w+)(?:\s*@([\d.%px]+))?(?:\s*:\s*"(.+)")?/);
        if (arrowMatch) {
            const typeMap = {
                "->": "normal",
                "=>": "thick",
                "~>": "corrupt",
                "-x": "dropped"
            };
            const type = typeMap[arrowMatch[4]];
            let tStart = arrowMatch[3] ? parseFloat(arrowMatch[3]) : undefined;
            let tEnd = arrowMatch[5] ? parseFloat(arrowMatch[5]) : undefined;
            // Rule: 
            // [start]=>      -> end=start
            //        =>[end] -> start=1
            // [start]=>[end] -> start=start, end=end
            if (type === "thick") {
                if (tStart !== undefined && tEnd === undefined) tEnd = tStart;
                else if (tEnd !== undefined && tStart === undefined) tStart = 1.0;
            }
            actions.push({
                type: "arrow",
                from: arrowMatch[1],
                start: arrowMatch[2] ? $6401b53bf7af177a$var$parseNumber(arrowMatch[2]) ?? undefined : undefined,
                arrowType: type,
                thicknessStart: tStart,
                thicknessEnd: tEnd,
                to: arrowMatch[7],
                end: arrowMatch[6] || arrowMatch[8] ? $6401b53bf7af177a$var$parseNumber(arrowMatch[6] || arrowMatch[8]) ?? undefined : undefined,
                label: arrowMatch[9]
            });
            continue;
        }
    }
    return {
        settings: settings,
        participants: participants,
        actions: actions,
        numAnnotations: numAnnotations
    };
}


function $f82b67f096a9a947$export$3bdb645cfef508e8(entities) {
    const { settings: settings, participants: participants, actions: actions, numAnnotations: numAnnotations } = entities;
    // 1. Calculate horizontal positions
    const timeUnitLabel = settings.showTimeTicks ? `Time ${settings.timeUnit}` : "";
    const timeAxisHeaderHalfWidth = timeUnitLabel.length * settings.participantFontSize * 0.3;
    const firstParticipantName = participants[0]?.name || "";
    const firstParticipantHalfWidth = firstParticipantName.length * settings.participantFontSize * 0.3;
    // Distance from the time axis header label to the left is fixed at paddingX.
    // We use max(halfWidth, 40) to also leave room for tick labels like "100" if the unit is short.
    const timeAxisX = settings.paddingX + Math.max(timeAxisHeaderHalfWidth, 40);
    const textBuffer = 20; // minimal gap between text labels
    const headerOverlapGap = timeAxisHeaderHalfWidth + firstParticipantHalfWidth + textBuffer;
    const annSpace = numAnnotations > 0 ? settings.annotationWidth + settings.labelOffset : 0;
    // Distance from axis line to first lifeline.
    const axisLineToParticipantGap = settings.showTimeTicks ? Math.max(headerOverlapGap, annSpace) : 20 + annSpace;
    const startX = settings.showTimeTicks ? timeAxisX + axisLineToParticipantGap : settings.paddingX + axisLineToParticipantGap;
    const lastParticipantX = startX + settings.participantSpacing * (participants.length - 1);
    const lastParticipantName = participants[participants.length - 1]?.name || "";
    const lastParticipantHalfWidth = lastParticipantName.length * settings.participantFontSize * 0.3;
    // Total width calculation
    const rightBuffer = Math.max(lastParticipantHalfWidth, annSpace);
    const width = lastParticipantX + rightBuffer + settings.paddingX;
    // 2. figure out top spacing for participant label and padding
    let height = settings.paddingY + settings.participantLabelHeight + settings.timeTickInterval; // last one is a hack
    // 3. resolve participant x position
    const participantsX = new Map(); // map alias -> x coord
    {
        let x = startX;
        for (const participant of participants){
            participantsX.set(participant.alias, x);
            x += settings.participantSpacing;
        }
    }
    // 4. resolve arrows and annotations
    let counter = 0, counterMax = counter;
    const draws = [];
    for (const action of actions)switch(action.type){
        case "arrow":
            // @ positioning on the source should modify the counter
            let startY = counter;
            let endY = counter + 1;
            if (action.start !== undefined) {
                counter = action.start;
                startY = counter;
                endY = counter + 1;
            }
            if (action.end !== undefined) endY = action.end;
            const startRatio = action.arrowType === "thick" ? action.thicknessStart ?? settings.thickArrowThickness : 0;
            const endRatio = action.arrowType === "thick" ? action.thicknessEnd ?? settings.thickArrowThickness : 0;
            const thicknessStart = startRatio * settings.timeTickInterval;
            const thicknessEnd = endRatio * settings.timeTickInterval;
            draws.push({
                type: action.type,
                x1: participantsX.get(action.from),
                y1: height + startY * settings.timeTickInterval,
                x2: participantsX.get(action.to),
                y2: height + endY * settings.timeTickInterval,
                arrowType: action.arrowType,
                thicknessStart: thicknessStart,
                thicknessEnd: thicknessEnd,
                label: action.label
            });
            counterMax = Math.max(counterMax, startY + startRatio, endY + endRatio);
            counter++;
            break;
        case "annotation":
            // @ positioning should just position and nothing else
            let y = counter;
            if (action.height !== undefined) y = action.height;
            draws.push({
                type: action.type,
                x: participantsX.get(action.participant) - (action.side == "left" ? 1 : -1) * settings.labelOffset,
                y: height + y * settings.timeTickInterval,
                align: action.side == "left" ? "right" : "left",
                text: action.text
            });
            counterMax = Math.max(counterMax, y);
            break;
    }
    // 5. resolve height of participant lifetimes
    // draws.reverse(); // TBC: might look better if one rendered above
    const oldHeight = height - settings.timeTickInterval; // another hack
    const totalTicks = Math.ceil(counterMax);
    height += (totalTicks + 1) * settings.timeTickInterval; // add some extra length to the lifetime
    const lifelines = participants.map((p)=>{
        return {
            type: "participant",
            x: participantsX.get(p.alias),
            y1: oldHeight,
            y2: height,
            name: p.name
        };
    });
    if (settings.showTimeTicks || settings.showGrid) {
        const step = Math.max(1, settings.timeTickStep);
        for(let i = 0; i <= totalTicks; i += step)draws.push({
            type: "tick",
            y: oldHeight + settings.timeTickInterval + i * settings.timeTickInterval,
            label: `${i}`
        });
    }
    if (settings.showTimeTicks) draws.push({
        type: "timeAxis",
        x: timeAxisX,
        y1: oldHeight,
        y2: height
    });
    height += settings.paddingY;
    return {
        settings: settings,
        width: width,
        height: height,
        draws: [
            ...lifelines,
            ...draws
        ]
    };
}


function $621f3774f67738fc$var$drawGrid(settings, ticks, width) {
    return ticks.map((tick)=>`<line stroke="#aaaaaa" stroke-dasharray="2" x1="0" y1="${tick.y}" x2="${width}" y2="${tick.y}" />`).join("\n");
}
function $621f3774f67738fc$var$drawTimeAxis(settings, axis, ticks) {
    const header = `
<text
  x="${axis.x}"
  y="${axis.y1 - settings.participantLabelHeight / 2}"
  text-anchor="middle"
  dominant-baseline="middle"
  font-family="JetBrains Mono, monospace"
  fill="white"
  font-size="${settings.participantFontSize}"
>
  Time ${settings.timeUnit}
</text>
<line stroke="#aaaaaa" stroke-width="3" x1="${axis.x}" y1="${axis.y1}" x2="${axis.x}" y2="${axis.y2}" />`;
    const tickElements = ticks.map((tick)=>`
<line stroke="#aaaaaa" x1="${axis.x - 5}" y1="${tick.y}" x2="${axis.x + 5}" y2="${tick.y}" />
<text
  x="${axis.x - 10}"
  y="${tick.y}"
  text-anchor="end"
  dominant-baseline="middle"
  font-family="JetBrains Mono, monospace"
  fill="white"
  font-size="${settings.messageFontSize}"
>
  ${tick.label}
</text>`).join("\n");
    return `${header}${tickElements}`;
}
function $621f3774f67738fc$var$drawParticipant(settings, participant) {
    const { x: x, y1: y1, y2: y2, name: name } = participant;
    return `
<text
  x="${x}"
  y="${y1 - settings.participantLabelHeight / 2}"
  text-anchor="middle"
  dominant-baseline="middle"
  font-family="JetBrains Mono, monospace"
  fill="white"
  font-size="${settings.participantFontSize}"
>
  ${name}
</text>
<line stroke="#aaaaaa" x1="${x}" y1="${y1}" x2="${x}" y2="${y2}" />`;
}
function $621f3774f67738fc$var$wrapText(text, maxChars) {
    const words = text.split(" ");
    const lines = [];
    let currentLine = "";
    for(let i = 0; i < words.length; i++){
        const word = words[i];
        if (currentLine.length === 0) currentLine = word;
        else if (currentLine.length + 1 + word.length <= maxChars) currentLine += " " + word;
        else {
            lines.push(currentLine);
            currentLine = word;
        }
    }
    if (currentLine) lines.push(currentLine);
    return lines;
}
function $621f3774f67738fc$var$drawAnnotation(settings, annotation) {
    const { x: x, y: y, align: align, text: text } = annotation;
    const charWidth = settings.messageFontSize * 0.6;
    const marginOffset = settings.labelOffset;
    const rectWidth = settings.annotationWidth - marginOffset;
    const maxChars = Math.max(1, Math.floor(rectWidth / charWidth));
    const lines = $621f3774f67738fc$var$wrapText(text, maxChars);
    const lineHeight = settings.messageFontSize * 1.2;
    const startY = y;
    const anchor = align === "left" ? "start" : align === "right" ? "end" : "middle";
    const tspans = lines.map((line, i)=>`<tspan x="${x}" y="${startY + i * lineHeight}">${line}</tspan>`).join("\n");
    return `
<text
  xml:space="preserve"
  text-anchor="${anchor}"
  dominant-baseline="middle"
  font-family="JetBrains Mono, monospace"
  fill="white"
  font-size="${settings.messageFontSize}"
>
  ${tspans}
</text>`;
}
function $621f3774f67738fc$var$drawArrow(settings, arrow) {
    const { x1: x1, y1: y1, x2: x2, y2: y2, arrowType: arrowType, thicknessStart: thicknessStart, thicknessEnd: thicknessEnd, label: label } = arrow;
    const dx = x2 - x1;
    const dy = y2 - y1;
    const len = Math.hypot(dx, dy);
    // normalized
    const ux = dx / len;
    const uy = dy / len;
    // normalized perpendicular
    const px = -uy;
    const py = ux;
    // arrow
    let arrowsvg = '';
    // arrow head
    const baseX = x2 - ux * settings.arrowHeadSize;
    const baseY = y2 - uy * settings.arrowHeadSize;
    const leftX = baseX + px * settings.arrowHeadSize * 0.5;
    const leftY = baseY + py * settings.arrowHeadSize * 0.5;
    const rightX = baseX - px * settings.arrowHeadSize * 0.5;
    const rightY = baseY - py * settings.arrowHeadSize * 0.5;
    switch(arrowType){
        case "normal":
            arrowsvg = `
<g stroke="white" stroke-width="2" fill="none" stroke-linecap="round">
  <line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" />
  <line x1="${x2}" y1="${y2}" x2="${leftX}" y2="${leftY}" />
  <line x1="${x2}" y1="${y2}" x2="${rightX}" y2="${rightY}" />
</g>`;
            break;
        case "dropped":
            // cross
            const dropX = x1 + ux * len * settings.dropStartRatio;
            const dropY = y1 + uy * len * settings.dropStartRatio;
            arrowsvg = `
<g stroke="white" stroke-width="2" fill="none" stroke-linecap="round">
  <line x1="${x1}" y1="${y1}" x2="${dropX}" y2="${dropY}" />
  <line stroke="red" x1="${dropX - settings.dropCrossSize * 0.5}" y1="${dropY - settings.dropCrossSize * 0.5}" x2="${dropX + settings.dropCrossSize * 0.5}" y2="${dropY + settings.dropCrossSize * 0.5}" />
  <line stroke="red" x1="${dropX - settings.dropCrossSize * 0.5}" y1="${dropY + settings.dropCrossSize * 0.5}" x2="${dropX + settings.dropCrossSize * 0.5}" y2="${dropY - settings.dropCrossSize * 0.5}" />
</g>`;
            break;
        case "corrupt":
            // draw the squiggly
            const waveX = x1 + ux * len * settings.corruptStartRatio;
            const waveY = y1 + uy * len * settings.corruptStartRatio;
            const waveLen = len * (1 - settings.corruptStartRatio) - 2 * settings.arrowHeadSize;
            const waveInterval = waveLen / (4 * settings.squiggleCount);
            let path = '';
            let sx = waveX;
            let sy = waveY;
            for(let i = 0; i < settings.squiggleCount; i++){
                sx += ux * waveInterval;
                sy += uy * waveInterval;
                path += `L ${sx - px * settings.squiggleSize * 0.5} ${sy - py * settings.squiggleSize * 0.5} `;
                sx += 2 * ux * waveInterval;
                sy += 2 * uy * waveInterval;
                path += `L ${sx + px * settings.squiggleSize * 0.5} ${sy + py * settings.squiggleSize * 0.5} `;
                sx += ux * waveInterval;
                sy += uy * waveInterval;
            }
            sx += ux * waveInterval;
            sy += uy * waveInterval;
            path += `L ${sx} ${sy}`;
            arrowsvg = `
<g stroke="white" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <line x1="${x1}" y1="${y1}" x2="${waveX}" y2="${waveY}" />
  <path stroke="orange" d="M ${waveX} ${waveY} ${path} L ${baseX} ${baseY}" />
  <line stroke="orange" x1="${baseX}" y1="${baseY}" x2="${x2}" y2="${y2}" />
  <line stroke="orange" x1="${x2}" y1="${y2}" x2="${leftX}" y2="${leftY}" />
  <line stroke="orange" x1="${x2}" y1="${y2}" x2="${rightX}" y2="${rightY}" />
</g>`;
            break;
        case "thick":
            const dx_b = x2 - x1;
            const dy_b = y2 + thicknessEnd - (y1 + thicknessStart);
            const len_b = Math.hypot(dx_b, dy_b);
            const ux_b = dx_b / len_b;
            const uy_b = dy_b / len_b;
            const px_b = -uy_b;
            const py_b = ux_b;
            const baseX_b = x2 - ux_b * settings.arrowHeadSize;
            const baseY_b = y2 + thicknessEnd - uy_b * settings.arrowHeadSize;
            const leftX_b = baseX_b + px_b * settings.arrowHeadSize * 0.5;
            const leftY_b = baseY_b + py_b * settings.arrowHeadSize * 0.5;
            const rightX_b = baseX_b - px_b * settings.arrowHeadSize * 0.5;
            const rightY_b = baseY_b - py_b * settings.arrowHeadSize * 0.5;
            arrowsvg = `
<g stroke="white" stroke-width="2" fill="none" stroke-linecap="round">
  <polygon stroke="none" fill="#ffffff44" points="${x1},${y1} ${x2},${y2} ${x2},${y2 + thicknessEnd} ${x1},${y1 + thicknessStart}" />
  <line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" />
  <line x1="${x2}" y1="${y2}" x2="${leftX}" y2="${leftY}" />
  <line x1="${x2}" y1="${y2}" x2="${rightX}" y2="${rightY}" />
  <line x1="${x1}" y1="${y1 + thicknessStart}" x2="${x2}" y2="${y2 + thicknessEnd}" />
  <line x1="${x2}" y1="${y2 + thicknessEnd}" x2="${leftX_b}" y2="${leftY_b}" />
  <line x1="${x2}" y1="${y2 + thicknessEnd}" x2="${rightX_b}" y2="${rightY_b}" />
</g>`;
            break;
    }
    // label
    let labelsvg = '';
    if (label) {
        const mx = (x1 + x2) / 2;
        const my = (y1 + y2) / 2;
        let offset = settings.labelOffset;
        let direction = 1;
        let angle = Math.atan2(dy, dx) * 180 / Math.PI;
        if (angle > 90 || angle < -90) {
            angle += 180;
            direction = -1;
            offset *= direction;
        }
        const lx = mx - px * offset;
        const ly = arrowType === "thick" ? my + direction * py * (thicknessStart + thicknessEnd) / 4 : my - py * offset;
        labelsvg = `
<text
  x="${lx}"
  y="${ly}"
  text-anchor="middle"
  dominant-baseline="middle"
  font-family="JetBrains Mono, monospace"
  transform="rotate(${angle} ${lx} ${ly})"
  fill="white"
  font-size="${settings.messageFontSize}"
>
  ${label}
</text>`;
    }
    return `${arrowsvg}${labelsvg}`;
}
function $621f3774f67738fc$export$c5f8399d19a7394b(entities) {
    const { settings: settings, width: width, height: height, draws: draws } = (0, $f82b67f096a9a947$export$3bdb645cfef508e8)(entities);
    let svg = [];
    svg.push(`<svg class="protocol-diagram" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">`);
    svg.push(`<rect width="100%" height="100%" fill="#333333"/>`);
    const ticks = draws.filter((d)=>d.type === "tick");
    const timeAxis = draws.find((d)=>d.type === "timeAxis");
    if (settings.showGrid) svg.push($621f3774f67738fc$var$drawGrid(settings, ticks, width));
    if (settings.showTimeTicks && timeAxis) svg.push($621f3774f67738fc$var$drawTimeAxis(settings, timeAxis, ticks));
    for (const draw of draws)switch(draw.type){
        case "participant":
            svg.push($621f3774f67738fc$var$drawParticipant(settings, draw));
            break;
        case "arrow":
            svg.push($621f3774f67738fc$var$drawArrow(settings, draw));
            break;
        case "annotation":
            svg.push($621f3774f67738fc$var$drawAnnotation(settings, draw));
            break;
    }
    //   svg.push(`<line
    //   x1=50
    //   y1=0
    //   x2=50
    //   y2=480
    //   stroke="#eeeeee"
    //   stroke-width=1
    // />
    // <line
    //   x1=330
    //   y1=0
    //   x2=330
    //   y2=480
    //   stroke="#eeeeee"
    //   stroke-width=1
    // />`);
    // svg.push(drawArrow("normal", 50, 50, 510, 100, "hello"));
    // svg.push(drawArrow("dropped", 510, 100, 50, 200, "hello indeed"));
    // svg.push(drawArrow("corrupt", 50, 200, 510, 300, "why u blue tick me?"));
    // svg.push(drawArrow("thick", 510, 300, 50, 430, "chonk"));
    //
    svg.push(`</svg>`);
    return svg.join("\n");
}


const $ea35524f8b95a2a5$var$preview = document.getElementById('preview');
const $ea35524f8b95a2a5$var$copyCodeBtn = document.getElementById('copyCode');
const $ea35524f8b95a2a5$var$copyPNGBtn = document.getElementById('copyPNG');
const $ea35524f8b95a2a5$var$copySVGBtn = document.getElementById('copySVG');
// Panel & Resizer elements
const $ea35524f8b95a2a5$var$panelRef = document.getElementById('panel-reference');
const $ea35524f8b95a2a5$var$panelEditor = document.getElementById('panel-editor');
const $ea35524f8b95a2a5$var$panelPreview = document.getElementById('panel-preview');
const $ea35524f8b95a2a5$var$resizerRef = document.getElementById('resizer-ref');
const $ea35524f8b95a2a5$var$resizerPreview = document.getElementById('resizer-preview');
const $ea35524f8b95a2a5$var$toggleRefBtn = document.getElementById('toggleReference');
// Resizing logic
function $ea35524f8b95a2a5$var$initResizer(resizer, leftPanel, rightPanel, isFirst) {
    let startX, startWidthLeft, startWidthRight;
    resizer.addEventListener('mousedown', (e)=>{
        if (e.target.id === 'toggleReference') return;
        startX = e.clientX;
        startWidthLeft = leftPanel.offsetWidth;
        startWidthRight = rightPanel.offsetWidth;
        // Disable transitions during resizing to prevent lag
        leftPanel.style.transition = 'none';
        const onMouseMove = (e)=>{
            const deltaX = e.clientX - startX;
            if (isFirst) {
                const newWidth = Math.max(0, startWidthLeft + deltaX);
                leftPanel.style.flex = `0 0 ${newWidth}px`;
                if ($ea35524f8b95a2a5$var$editor) $ea35524f8b95a2a5$var$editor.refresh();
            } else {
                const newWidth = Math.max(100, startWidthLeft + deltaX);
                leftPanel.style.flex = `0 0 ${newWidth}px`;
                if ($ea35524f8b95a2a5$var$editor) $ea35524f8b95a2a5$var$editor.refresh();
            }
        };
        const onMouseUp = ()=>{
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            resizer.classList.remove('dragging');
            document.body.style.cursor = 'default';
            // Re-enable transition after resizing
            leftPanel.style.transition = '';
            if ($ea35524f8b95a2a5$var$editor) $ea35524f8b95a2a5$var$editor.refresh();
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        resizer.classList.add('dragging');
        document.body.style.cursor = 'col-resize';
    });
}
// Toggle Reference logic
$ea35524f8b95a2a5$var$toggleRefBtn.addEventListener('click', (e)=>{
    e.stopPropagation();
    $ea35524f8b95a2a5$var$panelRef.classList.toggle('collapsed');
    const isCollapsed = $ea35524f8b95a2a5$var$panelRef.classList.contains('collapsed');
    $ea35524f8b95a2a5$var$toggleRefBtn.textContent = isCollapsed ? "\u25B6" : "\u25C0";
});
const $ea35524f8b95a2a5$var$REFERENCE_DATA = [
    {
        group: "Participants",
        items: [
            {
                title: "Define Participant",
                syntax: 'participant Name alias',
                example: 'participant Client c'
            },
            {
                title: "Participant Spacing",
                syntax: 'def participantSpacing 240px',
                example: 'def participantSpacing 240px'
            },
            {
                title: "Label Height",
                syntax: 'def participantLabelHeight 30px',
                example: 'def participantLabelHeight 30px'
            },
            {
                title: "Font Size",
                syntax: 'def participantFontSize 20px',
                example: 'def participantFontSize 20px'
            }
        ]
    },
    {
        group: "Message Arrows",
        items: [
            {
                title: "Normal Arrow",
                syntax: 'a -> b : "label"',
                example: 'a -> b : "Request"'
            },
            {
                title: "Variable Thick Arrow",
                syntax: 'a [start]=>[end] b : "label"',
                example: 'a [1.5]=> b : "Big Data"'
            },
            {
                title: "Corrupt Arrow",
                syntax: 'a ~> b : "label"',
                example: 'a ~> b : "Fragmented"'
            },
            {
                title: "Dropped Message",
                syntax: 'a -x b : "label"',
                example: 'a -x b : "Timeout"'
            },
            {
                title: "Time Offsets",
                syntax: 'a @1.5 -> b @1',
                example: 'a @1.5 -> b @1 : "Time Travel"'
            }
        ]
    },
    {
        group: "Arrow Styles",
        items: [
            {
                title: "Arrow Head Size",
                syntax: 'def arrowHeadSize 10px',
                example: 'def arrowHeadSize 10px'
            },
            {
                title: "Thick Ratio",
                syntax: 'def thickArrowThickness 1.0',
                example: 'def thickArrowThickness 1.0'
            },
            {
                title: "Label Offset",
                syntax: 'def labelOffset 10px',
                example: 'def labelOffset 10px'
            },
            {
                title: "Message Font Size",
                syntax: 'def messageFontSize 15px',
                example: 'def messageFontSize 15px'
            }
        ]
    },
    {
        group: "Corrupt & Dropped",
        items: [
            {
                title: "Corrupt Start %",
                syntax: 'def corruptStartRatio 85%',
                example: 'def corruptStartRatio 85%'
            },
            {
                title: "Drop Start %",
                syntax: 'def dropStartRatio 85%',
                example: 'def dropStartRatio 85%'
            },
            {
                title: "Drop Cross Size",
                syntax: 'def dropCrossSize 12px',
                example: 'def dropCrossSize 12px'
            },
            {
                title: "Corrupt Squiggle Size",
                syntax: 'def squiggleSize 20px',
                example: 'def squiggleSize 20px'
            },
            {
                title: "Corrupt Squiggle Count",
                syntax: 'def squiggleCount 2',
                example: 'def squiggleCount 2'
            }
        ]
    },
    {
        group: "Annotations",
        items: [
            {
                title: "Left Note",
                syntax: 'a < "text"',
                example: 'a < "Local check"'
            },
            {
                title: "Right Note",
                syntax: 'a > "text"',
                example: 'a > "Processing"'
            },
            {
                title: "Annotation Width",
                syntax: 'def annotationWidth 80px',
                example: 'def annotationWidth 80px'
            }
        ]
    },
    {
        group: "Grid & Time",
        items: [
            {
                title: "Show Grid",
                syntax: 'def showGrid true',
                example: 'def showGrid true'
            },
            {
                title: "Show Time Ticks",
                syntax: 'def showTimeTicks true',
                example: 'def showTimeTicks true'
            },
            {
                title: "Time Interval",
                syntax: 'def timeTickInterval 40px',
                example: 'def timeTickInterval 40px'
            },
            {
                title: "Time Tick Step",
                syntax: 'def timeTickStep 5',
                example: 'def timeTickStep 5'
            },
            {
                title: "Time Unit",
                syntax: 'def timeUnit /ms',
                example: 'def timeUnit /ms'
            }
        ]
    },
    {
        group: "Layout",
        items: [
            {
                title: "Horizontal Padding",
                syntax: 'def paddingX 30px',
                example: 'def paddingX 30px'
            },
            {
                title: "Vertical Padding",
                syntax: 'def paddingY 20px',
                example: 'def paddingY 20px'
            }
        ]
    }
];
function $ea35524f8b95a2a5$var$renderReference(filter = '') {
    const container = document.getElementById('reference-list');
    if (!container) return;
    container.innerHTML = ''; // Clear loading message
    const query = filter.toLowerCase().trim();
    $ea35524f8b95a2a5$var$REFERENCE_DATA.forEach((group)=>{
        const filteredItems = group.items.filter((item)=>item.title.toLowerCase().includes(query) || item.syntax.toLowerCase().includes(query) || group.group.toLowerCase().includes(query));
        if (filteredItems.length === 0) return;
        const groupEl = document.createElement('div');
        groupEl.className = 'ref-group';
        groupEl.innerHTML = `<h4>${group.group}</h4>`;
        const itemsContainer = document.createElement('div');
        itemsContainer.className = 'group-items';
        filteredItems.forEach((item)=>{
            const itemEl = document.createElement('div');
            itemEl.className = 'ref-item';
            const titleEl = document.createElement('div');
            titleEl.className = 'ref-title';
            titleEl.textContent = item.title;
            const codeEl = document.createElement('code');
            codeEl.className = 'ref-syntax';
            // Use the editor engine to highlight this static snippet!
            CodeMirror.runMode(item.syntax, 'protocol-ml', codeEl);
            const btn = document.createElement('button');
            btn.className = 'try-btn-small';
            btn.textContent = 'Try it';
            btn.addEventListener('click', ()=>{
                const currentValue = $ea35524f8b95a2a5$var$editor.getValue();
                const newValue = currentValue ? currentValue + '\n\n' + item.example : item.example;
                $ea35524f8b95a2a5$var$editor.setValue(newValue);
                $ea35524f8b95a2a5$var$editor.setCursor($ea35524f8b95a2a5$var$editor.lineCount(), 0);
                $ea35524f8b95a2a5$var$editor.focus();
            });
            itemEl.appendChild(titleEl);
            itemEl.appendChild(codeEl);
            itemEl.appendChild(btn);
            itemsContainer.appendChild(itemEl);
        });
        groupEl.appendChild(itemsContainer);
        container.appendChild(groupEl);
    });
    if (container.innerHTML === '' && query !== '') container.innerHTML = '<div class="loading">No results found for "' + filter + '"</div>';
}
const $ea35524f8b95a2a5$var$refSearch = document.getElementById('refSearch');
if ($ea35524f8b95a2a5$var$refSearch) $ea35524f8b95a2a5$var$refSearch.addEventListener('input', (e)=>{
    $ea35524f8b95a2a5$var$renderReference(e.target.value);
});
const $ea35524f8b95a2a5$var$INITIAL_CODE = `def timeTickInterval 40px
def participantSpacing 240px
def timeUnit /ms
def showTimeTicks true
def showGrid true

participant Alice a
participant Bob b

a -> b : "normal"
b -> a : "normal reply"

a ~> b : "corrupted"
b ~> a : "corrupted reply"

a -x b : "dropped"
b -x a : "dropped reply"

a => b : "thick reply"
b =>[1.5] a : "thicker reply (end 1.5)"

a @2 < "left label @2"
b @5 > "right label @5"`;
CodeMirror.commands.autocomplete = function(cm) {
    cm.showHint({
        hint: CodeMirror.hint["protocol-ml"]
    });
};
const $ea35524f8b95a2a5$var$editor = window.CodeMirror(document.getElementById('editor'), {
    value: $ea35524f8b95a2a5$var$INITIAL_CODE,
    mode: 'protocol-ml',
    lineNumbers: true,
    autofocus: true,
    tabSize: 2,
    indentUnit: 2,
    indentWithTabs: false,
    viewportMargin: Infinity,
    extraKeys: {
        "Ctrl-Space": "autocomplete",
        "Ctrl-/": "toggleComment",
        "Cmd-/": "toggleComment",
        "Tab": (cm)=>{
            if (cm.state.completionActive) cm.state.completionActive.pick();
            else {
                const cursor = cm.getCursor();
                const line = cm.getLine(cursor.line);
                const before = line.slice(0, cursor.ch);
                // If it's just whitespace before the cursor, indent. 
                // Otherwise try to complete.
                if (/^\s*$/.test(before)) return CodeMirror.Pass;
                cm.execCommand("autocomplete");
            }
        }
    },
    hintOptions: {
        direction: "above",
        completeSingle: false,
        alignWithWord: true
    }
});
// Auto-trigger hints while typing (VS Code style)
$ea35524f8b95a2a5$var$editor.on("inputRead", (cm, change)=>{
    if (change.text[0] === " " || change.text[0] === "\n") return;
    cm.showHint({
        hint: CodeMirror.hint["protocol-ml"]
    });
});
let $ea35524f8b95a2a5$var$currentSVG = '';
function $ea35524f8b95a2a5$var$render() {
    const code = $ea35524f8b95a2a5$var$editor.getValue();
    try {
        const diagram = (0, $6401b53bf7af177a$export$98e6a39c04603d36)(code);
        $ea35524f8b95a2a5$var$currentSVG = (0, $621f3774f67738fc$export$c5f8399d19a7394b)(diagram);
        $ea35524f8b95a2a5$var$preview.innerHTML = `<div class="protocol-ml-wrapper">${$ea35524f8b95a2a5$var$currentSVG}</div>`;
    } catch (err) {
        $ea35524f8b95a2a5$var$preview.innerHTML = `<div class="error">Error: ${err.message}</div>`;
        $ea35524f8b95a2a5$var$currentSVG = '';
    }
}
// Debounce rendering for performance
let $ea35524f8b95a2a5$var$renderTimeout;
$ea35524f8b95a2a5$var$editor.on('change', ()=>{
    clearTimeout($ea35524f8b95a2a5$var$renderTimeout);
    $ea35524f8b95a2a5$var$renderTimeout = setTimeout($ea35524f8b95a2a5$var$render, 300);
});
$ea35524f8b95a2a5$var$copyCodeBtn.addEventListener('click', async ()=>{
    try {
        await navigator.clipboard.writeText($ea35524f8b95a2a5$var$editor.getValue());
        $ea35524f8b95a2a5$var$copyCodeBtn.textContent = 'Copied!';
        $ea35524f8b95a2a5$var$copyCodeBtn.classList.add('copied');
        setTimeout(()=>{
            $ea35524f8b95a2a5$var$copyCodeBtn.textContent = 'Copy Code';
            $ea35524f8b95a2a5$var$copyCodeBtn.classList.remove('copied');
        }, 2000);
    } catch (err) {
        console.error('Failed to copy:', err);
    }
});
$ea35524f8b95a2a5$var$copyPNGBtn.addEventListener('click', async ()=>{
    if (!$ea35524f8b95a2a5$var$currentSVG) return;
    try {
        const svgElement = $ea35524f8b95a2a5$var$preview.querySelector('svg');
        if (!svgElement) return;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const svgData = new XMLSerializer().serializeToString(svgElement);
        canvas.width = svgElement.width.baseVal.value;
        canvas.height = svgElement.height.baseVal.value;
        const img = new Image();
        const svgBlob = new Blob([
            svgData
        ], {
            type: 'image/svg+xml;charset=utf-8'
        });
        const url = URL.createObjectURL(svgBlob);
        img.onload = async ()=>{
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(url);
            canvas.toBlob(async (blob)=>{
                try {
                    await navigator.clipboard.write([
                        new ClipboardItem({
                            'image/png': blob
                        })
                    ]);
                    $ea35524f8b95a2a5$var$copyPNGBtn.textContent = 'Copied!';
                    $ea35524f8b95a2a5$var$copyPNGBtn.classList.add('copied');
                    setTimeout(()=>{
                        $ea35524f8b95a2a5$var$copyPNGBtn.textContent = 'Copy PNG';
                        $ea35524f8b95a2a5$var$copyPNGBtn.classList.remove('copied');
                    }, 2000);
                } catch (err) {
                    console.error('Failed to copy PNG:', err);
                    $ea35524f8b95a2a5$var$copyPNGBtn.textContent = 'Failed';
                    setTimeout(()=>{
                        $ea35524f8b95a2a5$var$copyPNGBtn.textContent = 'Copy PNG';
                    }, 2000);
                }
            }, 'image/png');
        };
        img.onerror = ()=>{
            console.error('Failed to load SVG');
            URL.revokeObjectURL(url);
        };
        img.src = url;
    } catch (err) {
        console.error('Failed to copy PNG:', err);
    }
});
$ea35524f8b95a2a5$var$copySVGBtn.addEventListener('click', async ()=>{
    if (!$ea35524f8b95a2a5$var$currentSVG) return;
    try {
        await navigator.clipboard.writeText($ea35524f8b95a2a5$var$currentSVG);
        $ea35524f8b95a2a5$var$copySVGBtn.textContent = 'Copied!';
        $ea35524f8b95a2a5$var$copySVGBtn.classList.add('copied');
        setTimeout(()=>{
            $ea35524f8b95a2a5$var$copySVGBtn.textContent = 'Copy SVG';
            $ea35524f8b95a2a5$var$copySVGBtn.classList.remove('copied');
        }, 2000);
    } catch (err) {
        console.error('Failed to copy:', err);
    }
});
// Initial render
$ea35524f8b95a2a5$var$render();
$ea35524f8b95a2a5$var$renderReference();
$ea35524f8b95a2a5$var$initResizer($ea35524f8b95a2a5$var$resizerRef, $ea35524f8b95a2a5$var$panelRef, $ea35524f8b95a2a5$var$panelEditor, true);
$ea35524f8b95a2a5$var$initResizer($ea35524f8b95a2a5$var$resizerPreview, $ea35524f8b95a2a5$var$panelEditor, $ea35524f8b95a2a5$var$panelPreview, false);


//# sourceMappingURL=docs.27d5481d.js.map
